export const PAGE_PATH = '/event';
